import { Helmet } from "react-helmet-async";
import { HOME } from '../src/services/api/config';
import LogoImage from '../src/assets/images/Scholar-Box-Logo.png';

interface HelmetProps {
    title: string,
    description: string,
    name: string,
    type: string,
    keywords: string,
    jsonLDs?: object[] // Array of JSON-LD objects for structured data
}

const HelmetHeader = ({ title, description, name, type, keywords, jsonLDs = [] }: HelmetProps) => {
    const isProduction = process.env.NODE_ENV === 'production' ? true : false;
    return (
        <Helmet>
            <meta charSet="utf-8" />
            <link rel="canonical" href={window.location.href} />

            {/* Hreflang Tags */}
            <link rel="alternate" href={window.location.href + "/us"} hreflang={"en-us"} />

            { /* Standard metadata tags */}
            <title>{title}</title>
            <meta name='description' content={description} />
            <meta name="keywords" content={keywords} />
            { /* End standard metadata tags */}
            { /* Facebook tags */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={LogoImage} />
            <meta property="og:url" content={HOME} />
            { /* End Facebook tags */}
            { /* Twitter tagss */}
            <meta name="twitter:creator" content={name} />
            <meta name="twitter:card" content={type} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            { /* End Twitter tags */}

            {jsonLDs && jsonLDs.map((jsonLD, index) => (
                jsonLD != null && JSON.stringify(jsonLD) != '{}' ?
                    <script key={index} type="application/ld+json">
                        {JSON.stringify(jsonLD, null, 2)}
                    </script>
                    : null
            ))}
            {/* <!-- Clarity code goes here for MS Clarity --> */}
            {isProduction && (
                <script type="text/javascript">
                    {`(function(c,l,a,r,i,t,y){
                    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "pbs1qdgbg7");`}
                </script>
            )}

            {/* <!-- Hotjar code for Scholar Box goes here --> */}
            {isProduction && (
                <script>
                    {`(function(h,o,t,j,a,r){
                    h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
                h._hjSettings={hjid:5236846,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`}
                </script>
            )}
        </Helmet>
    )
}

export default HelmetHeader;